// ==============================|| TYPES ||============================== //

export type PropsWithDeliveryPointId<T = unknown> = T & {
  deliveryPointId: string;
};

export enum ReservedCapacityGuardingCheckResultStatus {
  ACTIONS_NOT_NEEDED = 'ACTIONS_NOT_NEEDED',
  ACTIONS_ISSUED = 'ACTIONS_ISSUED',
  ACTIONS_ISSUED_RESERVED_CAPACITY_EXCEEDED = 'ACTIONS_ISSUED_RESERVED_CAPACITY_EXCEEDED'
}
